module.exports = __webpack_public_path__ + "static/media/avatar_giraffe.10f1706a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_giraffe.png
// module id = 382
// module chunks = 0